export default class Fade extends Component {
  constructor(props) {
    super(props)
    this.state = { show: true, animationFinished: false }

    props.duration && setTimeout(() => this.setState({ show: false }), props.duration)
  }

  render() {
    const { duration, children } = this.props

    if (this.state.animationFinished) {
      return null
    }

    return (
      <CSSTransition
        classNames="animate-fade"
        in={this.state.show}
        timeout={500}
        appear={true}
        enter={false}
        exit={Boolean(duration)}
        onExited={() => this.setState({animationFinished: true})}
      >
       {children}
      </CSSTransition>
    )
  }
}
